<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Video Manager"></app-sub-header>
                    </div>
                    <div class="col-md-12">
                        <div class="margin-b" style="text-align: end;">
                            <button routerLink='add-video' class="btn  main-backgroundcolor color">
                                Add Video</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="min-height">
                            <div *ngIf="!loading" class="accordion" id="accordionExample">
                                <div class="card" *ngFor="let props of arr; let i = index">
                                    <div class="card-header" id="heading{{i}}">
                                        <h2 class="mb-0">
                                            <button class="btn btn-block text-left" type="button" data-toggle="collapse"
                                                attr.data-target="#collapse{{i}}" aria-expanded="true"
                                                aria-controls="collapse{{i}}">
                                                <app-skelton></app-skelton>
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapse{{i}}" class="collapse " aria-labelledby="heading{{i}}"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            <app-skelton></app-skelton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="loading" class="accordion" id="accordionExample">
                                <div class="card">
                                    <div class="card-header main-backgroundcolor" id="headingOne">
                                        <h2 class="mb-0">
                                            <button class="btn color accrdn-btn" type="button" data-toggle="collapse"
                                                [ngClass]="{'collapsed': sliderArr.length == 0}"
                                                data-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                Slider Videos
                                                <i class="fas fa-plus-circle"></i>
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                        data-parent="#accordionExample">
                                        <app-no-results-found *ngIf="sliderArr.length == 0 " title='Video'>
                                        </app-no-results-found>

                                        <div class="card-body" *ngFor="let props of sliderArr; let i = index">
                                            <div class="card">
                                                <!-- <iframe class="card-img-top" [class.thumbnail]="thumbnail" [src]="transform(props.videoUrl)"
                                                    frameborder="0" webkitallowfullscreen mozallowfullscreen                                                    allowfullscreen></iframe> -->
                                                <div style="position: relative;">
                                                    <a [href]="props.videoUrl" target="_blank" class="cursor">
                                                        <img [src]="renderImage(props)" class="card-img-top image-style"
                                                            (error)="getErrorImage($event,props)">
                                                        <!-- <div class="pos">
                                                            <p>{{props.duration | date:'h:mm:ss'}}</p>
                                                        </div> -->
                                                    </a>
                                                </div>
                                                <div class="card-body">
                                                    <h5 class="card-title">{{props.videoTitle}}</h5>
                                                    <!-- <p class="card-text">Some quick example text to build on the card
                                                        title and make up the bulk of the card's content.</p> -->
                                                    <div class="display">
                                                        <div style="text-align: end; width: 100%;">
                                                            <a class="btn main-backgroundcolor color"
                                                                (click)="navigate(props._id)">Edit</a>
                                                            <a class="btn btn-danger margin-l"
                                                                (click)="deleteVideo(props._id,'slider',i)">Delete</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header main-backgroundcolor color" id="headingTwo">
                                        <h2 class="mb-0">
                                            <button class="btn  accrdn-btn color collapsed"
                                                [ngClass]="{'collapsed': legecyArr.length == 0}" type="button"
                                                data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                                                aria-controls="collapseTwo">
                                                Legacy Videos
                                                <i class="fas fa-plus-circle"></i>
                                            </button>
                                           
                                        </h2>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                        data-parent="#accordionExample">
                                        <app-no-results-found *ngIf="legecyArr.length == 0 " title='Video'>
                                        </app-no-results-found>
                                        <div class="card-body" *ngFor="let props of legecyArr; let i = index">
                                            <div class="card">
                                                <!-- <iframe class="card-img-top" [class.thumbnail]="thumbnail" [src]="transform(props.videoUrl)"
                                                    frameborder="0" webkitallowfullscreen mozallowfullscreen
                                                
                                                    allowfullscreen></iframe> -->
                                                <div style="position: relative;">
                                                    <a [href]="props.videoUrl" target="_blank" class="cursor">
                                                        <img [src]="renderImage(props)" class="card-img-top image-style"
                                                            (error)="getErrorImage($event,props)"
                                                            class="card-img-top image-style">
                                                        <div class="pos">
                                                            <!-- <p>{{props.duration | date:'h:mm:ss'}}</p> -->
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="card-body">
                                                    <h5 class="card-title">{{props.videoTitle}}</h5>
                                                    <!-- <p class="card-text">Some quick example text to build on the card
                                                        title and make up the bulk of the card's content.</p> -->
                                                    <div class="display">
                                                        <div style="text-align: end; width: 100%;">
                                                            <a class="btn main-backgroundcolor color"
                                                                (click)="navigate(props._id)">Edit</a>
                                                            <a class="btn btn-danger margin-l"
                                                                (click)="deleteVideo(props._id,'legecy')">Delete</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
































                            <!-- 
                            <div class="card" *ngFor ="let props of objArr">
                             <div class="card-body" >

    <p (click)="navigate(props._id)">{{props.videoTitle}}</p>
                            <button class="btn btn-sm main-backgroundcolor color" (click)="deleteVideo(props._id)">
                                Delete
                            </button>

                             </div>
                            </div> -->



                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <router-outlet></router-outlet>